import { Box, styled } from "@mui/material";
import Text from "../Text";

interface StyledArrowIconWrapperProps {
  disabled?: boolean;
}

export const StyledArrowIconWrapper = styled(Box)<StyledArrowIconWrapperProps>`
  display: flex;

  ${({ theme: { wsc }, disabled }) => `
    color: ${wsc.palette.neutral[disabled ? 300 : 100]};
    cursor: ${disabled ? "default" : "pointer"};
    
    ${
      !disabled &&
      `
        &:hover {
          transform: scale(1.05);
        }

        &:active {
          transform: scale(0.95);
        }
      `
    }
  `}
`;

export const StyledArrowIconsWrapper = styled(Box)`
  display: flex;
  flex-direction: column;
  cursor: default;
`;

export const StyledText = styled(Text)`
  &&& input {
    ::-webkit-outer-spin-button,
    ::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }
  }

  input[type="number"] {
    -moz-appearance: textfield;
  }
`;
